module.exports = __webpack_public_path__ + "img/1.6f073b14.png";